import React from 'react'
import { NavLink } from 'react-router-dom'
import { Card, Label, Menu } from 'semantic-ui-react'

import BillingInvoicePdfItem from 'components/superuser/billing/BillingInvoicePdfItem'
import CreditNoteBillingInvoiceItem from 'components/superuser/billing/CreditNoteBillingInvoiceItem'
import SendBillingInvoiceEmailItem from 'components/superuser/billing/SendBillingInvoiceEmailItem'
import SendBillingInvoicePeppolItem from 'components/superuser/billing/SendBillingInvoicePeppolItem'
import TogglePaidBillingInvoiceItem from 'components/superuser/billing/TogglePaidBillingInvoiceItem'
import { displayStatus, statusColor } from 'components/superuser/billing/invoiceStatus'

export default function BillingInvoicesListItem ({ billingInvoice }) {
  const inv = billingInvoice
  const status = displayStatus(inv)
  const formatAmount = (amount) => (amount == null ? '—' : `€ ${Number(amount).toFixed(2)}`)

  return (
    <Card>
      <Card.Content as={NavLink} to={Routes.superuser_billing_invoice_path({ id: inv.id })}>
        <Card.Header>{inv.formattedIdentification || 'Draft'}</Card.Header>
        <Card.Meta>{inv.customerName || `Subscription #${inv.subscriptionId}`}</Card.Meta>
        <Card.Meta>{inv.invoiceDate || '—'} → {inv.dueDate || '—'}</Card.Meta>
      </Card.Content>
      <Card.Content extra>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Label color={statusColor(status)}>{status}</Label>
          <span style={{ fontSize: '1.3rem', fontWeight: 300 }} title="Total incl. VAT">
            {formatAmount(inv.totalInclVat)}
          </span>
        </div>
      </Card.Content>
      <Card.Content extra style={{ padding: 0 }}>
        <Menu compact icon borderless secondary size="large">
          <BillingInvoicePdfItem billingInvoice={inv}/>
          <SendBillingInvoiceEmailItem billingInvoice={inv}/>
          <SendBillingInvoicePeppolItem billingInvoice={inv}/>
          <TogglePaidBillingInvoiceItem billingInvoice={inv}/>
          <CreditNoteBillingInvoiceItem billingInvoice={inv}/>
        </Menu>
      </Card.Content>
    </Card>
  )
}
